/*
LP DIGITAL
JS v1.0.2
required: jquery
*/


$(document).ready(function() {

	//Apply class mb-sm-0 to remove margn bottom in mobile for list has check into cols. Like that there is no space between the lists
	$('div.row .content:has(ul.list-has-check)').addClass('mb-md-0');
	console.log($("ul.list-has-check").parents('div.content').length);
	$("ul.list-has-check").each(function(){
		if($(this).parents('div.row').length){
			$(this).addClass('mb-md-0');
		}
	});

	//init SHORTCUTS
	$("#access-shortcuts-wrapper>ul").initShortcuts();

	// Resize video on window resize
	$(".BrightcoveExperience").resizeEmbed();

	// Smooth scroll
	// See: http://css-tricks.com/snippets/jquery/smooth-scrolling/
	// Select all links with hashes
	$('a[href*="#"]')
	  // Remove links that don't actually link to anything
	  .not('[href="#"]')
	  .not('[href="#0"]')
	  .click(function(event) {
		// On-page links
		if (
		  location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '')
		  &&
		  location.hostname == this.hostname
		) {
		  // Figure out element to scroll to
		  var target = $(this.hash);
		  target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
		  // Does a scroll target exist?
		  if (target.length) {
			// Only prevent default if animation is actually gonna happen
			event.preventDefault();
			$('html, body').animate({
			  scrollTop: target.offset().top
			}, 1000, function() {
			  // Callback after animation
			  // Must change focus!
			  var $target = $(target);
			  $target.focus();
			  if ($target.is(":focus")) { // Checking if the target was focused
				return false;
			  } else {
				$target.attr('tabindex','-1'); // Adding tabindex for elements not focusable
				$target.focus(); // Set focus again
			  };
			});
		  }
		}
	  });
	//

	//Marquee
	$(".content-home-twitter div > ul").marquee();

	//Menu mobile
	var menuMobile = $( '#dl-menu' ).dlmenu({
		animationClasses: {classin: 'dl-animate-in-2', classout: 'dl-animate-out-2', backLabel: 'Retour', useActiveItemAsBackLabel: true}
	});

	$('.header-toolbar-mobile-wrapper .btn-toggle-menu').on("click",function(){
			var self = $(this);
			if(!$(menuMobile).find(".dl-trigger").hasClass("dl-active")){

				// > search: removing drp back + btn active
				$('body .drp-back').remove();
				$(".mobile-submenu-container .mobile-submenu-search").removeClass('open');
				$('.header-toolbar-mobile-wrapper .btn-toggle-search').removeClass('active');
				//

				setTimeout(function(){menuMobile.dlmenu("openMenu")
				$('body').one( 'click.dlmenu', function() {
					self.removeClass('active');
				} );
				},100);
				$(this).addClass('active');

			}else {
				$(this).removeClass('active');
			}
	});

	$('.header-toolbar-mobile-wrapper .btn-toggle-search').on("click",function(e){
			e.preventDefault();
			var self = $(this);
			if(self.hasClass("active")){
				self.removeClass('active');
				$(".mobile-submenu-container .mobile-submenu-search").removeClass('open');
			}else {
				self.addClass('active');
				$(".mobile-submenu-container .mobile-submenu-search").addClass('open');
				$("body").append($("<div></div>").addClass("drp-back"));
				// > search: removing drp back + btn active
				$('body .drp-back').one( 'click', function() {
					$(this).remove();
					$(".mobile-submenu-container .mobile-submenu-search").removeClass('open');
					$('.header-toolbar-mobile-wrapper .btn-toggle-search').removeClass('active');
				});
			}
	});

	var fn_search_nav = function () {

		// popover footer
		var search_button = $('.nav-item-button-search');
		var search_button_txt = $('.nav-item-button-search span + span');
		var search_wrapper = $('.nav-item-block-search');

		search_button.on('click', function () {
			if( $(this).hasClass('open') ) {
				$(this).removeClass('open').attr('aria-expanded', 'false');
				search_button_txt.html('Ouvrir la recherche');
				search_wrapper.removeClass('show').attr('aria-hidden', 'true');
			} else {
				$(this).addClass('open').attr('aria-expanded', 'true');
				search_button_txt.html('Fermer la recherche');
				search_wrapper.addClass('show').attr('aria-hidden', 'false');
			}
		});
	}

	fn_search_nav();

	//Fancy box
	if ($.isFunction($.fancybox)){
		$(".fancybox").attr('rel', 'mediaGallery').fancybox({
				tpl: {
						closeBtn: '<div title="Fermer" class="fancybox-item fancybox-close linkedImage"></div>',
						next: '<a title="Suivant" class="fancybox-nav fancybox-next"><span></span></a>',
						prev: '<a title="PrÃ©cÃ©dent" class="fancybox-nav fancybox-prev"><span></span></a>'
				},
				titleShow:true

		});
	}

	$(".lib-icon-zoom").each(function(){
		$(this).attr("href",$(this).attr("title"));
	});

	//Accordion -> FAQ
	$( ".accordion" ).accordion({
		icons: {
			header: "fa fa-angle-down",
			activeHeader: "fa fa-angle-up"
		},
		heightStyle: "content",
		animate: false,
		collapsible: true
	});

	//Printer Fn
	$('.button-print').on('click', function(e) {
		e.preventDefault();
		window.print();
	});

	//Masthead - cover video
	// Adding class ".device-not-mobile" to activate video injection only on desktop browser
	$('.content-banner-video').each(function(){
		var bannerVideo = $(this);

		// Video set up on non mobile device test + min screen width
		if ($('body').outerWidth() > 992) {
			// Creating video in masthead
			// autoplay if bypassing poster video
			var videoPath = bannerVideo.data('video'),
					covervid = $('<div class="data-is-video-wrapper animated fadeIn"><video autoplay class="data-is-video" muted loop poster="'+videoPath+'.jpg"><source src="'+videoPath+'.webm" type="video/webm"><source src="'+videoPath+'.mp4" type="video/mp4"></video></div>');

			bannerVideo.append(covervid).toggleClass('has-loader');
			setTimeout(function() {
				bannerVideo.css('background-image','');
				$('.data-is-video').coverVid(1280, 720);
				$(window).trigger('resize');
			},200);
		}
		else {
			bannerVideo.css('background-image','url(' + bannerVideo.data("cover") + ')');
			bannerVideo.find('.data-is-video-wrapper').remove();
		}

	});
	//
	//Is in viewport detection - see Masthead JS + Covervid JS
	// > Pause video when out of viewport
	//See: https://github.com/zeusdeux/isInViewport
	if ($.fn.isInViewport) {
		$(window).scroll(function() {
			$('video').each(function(){
				//
				if ($(this).is(":in-viewport( -260 )")) {
					//
					$(this)[0].play();
				} else {
					//
					$(this)[0].pause();
				}
			})
		});
	} else {
		if (console) {
			console.error('Please load isInViewport, see https://github.com/zeusdeux/isInViewport');
		}
	}
	//

	//
	$('.section-main-search .icon-loupe-pink').on('click', function(e) {
		var $form = $(this).closest('form');
		e.preventDefault();

		if ($form.hasClass('is-open')) {
			$form.submit();
		} else {
			$form.addClass('is-open');
			setTimeout(function() {
				$form.find('.form-box-input-container input').focus();
			}, 100);
			$('body').on('click.myNamespace', function(e) {
				if ($(e.target).parents('.section-main-search').length === 0) {
					$form.removeClass('is-open');
					$('body').off('click.myNamespace');
				}
			});
		}

	});

    // offer affix
	var fn_offer_affix = function() {
        var offerListAffixElt = $('[data-smart-affix]');

	    if (Modernizr.mq('all and (min-width: 992px)')) {
            var offerListAffixWidth = $(".o-offer-list-content").outerWidth();
            var offerListAffixPositionLeft = ($(window).width() - ($(".o-offer-list-content").offset().left + $(".o-offer-list-content").outerWidth()));

            offerListAffixElt.each(function() {
                $(this).affix({
                    offset: {
                        top: $(".o-offer-list-content").offset().top
                    }
                });

                $(this).css({
                    'top' : 0,
                    'left' : offerListAffixPositionLeft,
                    'width' : offerListAffixWidth
                });
            });
        } else {

            //destroy affix
            $(window).off('.affix');
            offerListAffixElt.removeAttr("style").removeClass('affix affix-top affix-bottom').removeData();

        }
    }

    var fn_offer_affix_height = function() {
	    if (Modernizr.mq('all and (min-width: 992px)')) {
            $(window).scroll(function () {
                var bottomLimitElt = document.getElementById("offer-bottom-limit");
                var bottomLimitRect = bottomLimitElt.getBoundingClientRect();

                if (!isElementOutViewport(bottomLimitElt)) {
                    var footerHeightVisible = window.innerHeight - bottomLimitRect.top;
                    var offerListNewHeight = "calc(100% - " + footerHeightVisible + "px - 50px)"; // remove 50px to add some space between list block and footer

                    $('.offer-list .o-offer-list-display').css("height", offerListNewHeight);
                } else {
                    $('.offer-list .o-offer-list-display').css("height", "100%");
                }
            });
        }
    }

	if ($(".offer-list").length > 0) {
        fn_job_offer();
        fn_offer_affix();
        fn_offer_affix_height();

        $(window).on("resize", function() {
            fn_job_offer();
            fn_offer_affix();
            fn_offer_affix_height();
        });
    }

	//init Navigation --> see window resize
	$("#nav-primary").initNav({subMenuRelativeWrapper: $("#nav").parent().parent()});

	//RWD checking Fn
	checkMq();

    //Sticky NAv
    affixFix();

    $('form.powermail_form').on('submit', function(){
            $(this).find(':submit').hide();
            $(this).find(':submit').after('<img src="typo3conf/ext/lpcircet/Resources/Public/img/loaderupload.gif" />');
    });

	// img into background image cover
	$('.cover').each(function (i, el) {
        var $el = $(el);
        var $img = $el.find('>img, >a>img').eq(0);

        function setBackgroundImage(url) {
            if (!url) {
                return;
            }
            $el.css('background-image', 'url(' + url + ')');
        }
        setBackgroundImage($img.attr('src'));
    });
//END ready
});
//


// window resize
$(window).resize(function() {
	//
	$("#nav-primary").initNav({'resize': true});

	//RWD checking Fn
	checkMq();

	// re-position details into the right div
	fn_move_infos();

	//RWD Header Resizing Fn
	//checkHeaderH();

	//Sticky NAv
	affixFix();

});
// End window resize


// window load
$(window).load(function(){

	$('.content-slideshow .slider-list').each(function () {
		var $slider = $(this),
			sliderOptions = {
			autoplay: true,
			autoplayTimeout: 6000,
			autoplayHoverPause: false,
			nav: $slider.hasClass('has-nav'),
			dots: $slider.hasClass('has-pagination'),
			loop: true,
			rewind: true,
			center: false,
			items: 1,
			lazyLoad: true,
			navText: ['<span class="sr-only">Précédent</span><i class="fa fa-angle-left"></i>','<span class="sr-only">Suivant</span><i class="fa fa-angle-right"></i>'],
			onInitialized: function () {
				$slider.removeClass('slider-loader');
			}
		};
		$slider.owlCarousel(sliderOptions);
	});

	$('.news-slider-wrapper .slider-list').each(function () {
		var $slider = $(this),
			sliderOptions = {
				autoplay: true,
				autoplayTimeout: 6000,
				autoplayHoverPause: false,
				nav: $slider.hasClass('has-nav'),
				dots: $slider.hasClass('has-pagination'),
				loop: true,
				rewind: true,
				center: false,
				items: 1,
				lazyLoad: true,
				navText: ['<span class="sr-only">Précédent</span><i class="fa fa-angle-left"></i>','<span class="sr-only">Suivant</span><i class="fa fa-angle-right"></i>'],
				onInitialized: function () {
					$slider.removeClass('slider-loader');
				}
			};
		$slider.owlCarousel(sliderOptions);
	});

	$('.content-partners .slider-list').each(function () {
		var $slider = $(this),
			sliderOptions = {
				autoplay: true,
				autoplayTimeout: 2000,
				autoplayHoverPause: true,
				nav: $slider.hasClass('has-nav'),
				dots: $slider.hasClass('has-pagination'),
				loop: true,
				rewind: false,
				items: 2,
				slideBy: 1,
				navText: ['<span class="sr-only">Précédent</span><i class="fa fa-angle-left"></i>','<span class="sr-only">Suivant</span><i class="fa fa-angle-right"></i>'],
				autoWidth: false,
				autoHeight: false,
				pagination: false,
				// rewindNav: true,
				margin: 0,
				// URLhashListener: true,
				// startPosition: 'URLHash',
				responsiveClass: true,
				responsive: {
				768: {
					items: 3,
					slideBy: 1,
					nav: false
				},
				1200: {
					items: 5,
					slideBy: 1,
					nav: false
				}
				},
				onInitialized: function () {
					$slider.removeClass('slider-loader');
				}
			};
		$slider.owlCarousel(sliderOptions);
	});

	// > Slider-hero
	$('.owl-carousel.slider-hero').each(function () {
		var $slider = $(this),
			sliderOptions = {
				items: 1,
				slideBy: 1,
				autoplay: true,
				autoplayTimeout: 7000,
				loop: false,
				rewind: true,
				nav: false,
				navText: ['<span class="sr-only">Précédent</span><i class="fa fa-angle-left"></i>','<span class="sr-only">Suivant</span><i class="fa fa-angle-right"></i>'],
				rewindNav: true,
				margin: 0,
				// URLhashListener: true,
				// startPosition: 'URLHash',
				responsiveClass: true,
				responsive: {
					992: {
						nav: false
					},
					1200: {
						nav: true
					}
				}
			};
		$slider.owlCarousel(sliderOptions);
	});

	// Show loading gif when a form is submitted
	//  $('button[type="submit"]').closest('form').on('submit', function() {
	$('#dmmjobcontrol_apply_form, .powermail_form').on('submit', function() {
		if((typeof validForm !== 'undefined' && validForm === true) || typeof validForm === 'undefined'){ // validForm is only used for the jobcontrol apply forms
			// Hide the button
			$(this).find('button[type="submit"]').hide();
			// Display the loading image
			$(this).find('button[type="submit"]').after('<img src="typo3conf/ext/lpcircet/Resources/Public/img/loaderupload.gif" />');
		}
	});

	//RWD Header Resizing Fn
	//checkHeaderH();

});
// End window load


//initShortcuts
$.fn.initShortcuts = function(options) {

	var obj = $(this);
	obj.find('a').focus(function(e) {obj.css('height', 'auto'); });
	obj.find('a').blur(function(e) {obj.css('height', '0px'); });

	return this;
};


//initNav
(function($) {
	$.fn.positionNav = function() {
		var obj = $(this);
		var sections = obj.find(' > li');
		var subnavs = sections.find('> ul');
		var documentW = $('.navbar-wrapper > .rw').width();

		sections.each(function() {
			var section = $(this);
			var subMenuContainer = section.find('> .meganav-wrapper');
			if (subMenuContainer.length > 0) {
				if (section.width() + section.position().left < subMenuContainer.outerWidth()) {
					subMenuContainer.css('left', -section.position().left);
				} else {
					subMenuContainer.css({'left': 'auto', 'right': 0});
				}
			}
		});
	};

	//initNav
	$.fn.initNav = function(options) {
		var defaults = {
			offClass: "visuallyhidden",
			activeClass: "nav-opened", //nav-selected
			timeOut: 200,
			resize: false
		};

		var options = $.extend(defaults, options);
		var obj = $(this);
		var sections = obj.find(' > li');
		var subnavs = sections.find('> ul');
		var a = 0;
		var navbarheight = $('.bav-relative-wrapper').height;

		var deviceAgent = navigator.userAgent.toLowerCase();
		//var agentID = deviceAgent.match(/(iphone|ipod|ipad|android)/);
		var pattern = /iphone|ipod|ipad|android/;
		var agentID = pattern.test(deviceAgent);

		subnavs.addClass(options.offClass);
		obj.parent().parent().css('position', 'relative');
		//obj.positionNav();


		if (options.resize === true) {
			return;
		}

		sections.find('.subnav-open').removeClass('subnav-open');

		//Gestion ouverture sous-menu
		sections.each(function() {
			var section = $(this);
			var subMenu = section.find('.meganav-wrapper');
			var liens = section.find("a, span");

			//POSITION SUBMENU
			/*
			var subMenuContainer = section.find('> .meganav-wrapper');
			var subMenuContainerW = subMenuContainer.outerWidth()
			if ((section.offset().left + subMenuContainerW) > documentW ){
			subMenuContainer.css('left', documentW - (section.offset().left + subMenuContainerW) - 10 );
			}*/

			liens.each(function() {
				var $link = $(this);

				if ($link.parent().hasClass('has-child')) {
					$link.on('click touchend', function(e) {

						e.preventDefault();
						var meganav = $(this).closest('.meganav-wrapper');
						var subnav = $(this).parent().find('ul').clone();
						$(this).addClass('click');
						meganav.addClass('subnav-open');
						meganav.find('.subnav-cloned').remove();
						meganav.append(subnav.addClass('subnav-cloned'));
						return false;
					});
				}
			});

			if (!agentID) {
				liens.bind("focus", function() {
					sections.not(section).removeClass(options.activeClass);
					subnavs.not(subMenu).addClass(options.offClass);
					section.addClass(options.activeClass);
					subMenu.removeClass(options.offClass);
					sections.not(section).find('.subnav-open .subnav-cloned').remove();
					sections.not(section).find('.subnav-open').removeClass('subnav-open');

					window.clearTimeout(a);
					$(this).removeClass("click");
				});
				liens.bind("blur", function() {
					a = window.setTimeout(function() {
						section.removeClass(options.activeClass);
						subMenu.addClass(options.offClass);
					}, options.timeOut);
					$(this).removeClass("click");
				});
				section.bind("mouseover", function() {
					var navHeight = section.height();
					subMenu.css("top", navHeight);

					sections.not(section).removeClass(options.activeClass);
					subnavs.not(subMenu).addClass(options.offClass);
					section.addClass(options.activeClass);
					subMenu.removeClass(options.offClass);
					sections.not(section).find('.subnav-open .subnav-cloned').remove();
					sections.not(section).find('.subnav-open').removeClass('subnav-open');

					window.clearTimeout(a);
					$(this).find('> a').removeClass("click");
					//b.not(g).hide();
					//g.show()
				});
				section.bind("mouseleave", function() {
					a = window.setTimeout(function() {
						section.removeClass(options.activeClass);
						subMenu.addClass(options.offClass);
						sections.not(section).find('.subnav-open .subnav-cloned').remove();
						sections.not(section).find('.subnav-open').removeClass('subnav-open');
					}, options.timeOut);
					$(this).find('> a').removeClass("click");
				});
			} else {
				section.on("touchend", "a", function(e) {
					if (!$(this).is('span')) {
						e.preventDefault();
						var href = $(this).attr("href");
						var target = $(this).attr("target");
						var toClick = false;

						sections.not(section).find('.subnav-open .subnav-cloned').remove();
						sections.not(section).find('.subnav-open').removeClass('subnav-open');

						sections.not(section).removeClass(options.activeClass);
						subnavs.not(subMenu).addClass(options.offClass);
						section.addClass(options.activeClass);
						subMenu.removeClass(options.offClass);

						if ($(this).next().size() > 0) {
							if (!$(this).hasClass("click")) {
								$(this).addClass("click");
							} else {
								toClick = true;
							}
						} else {
							toClick = true;
						}
						if (toClick) {
							if (target == "_blank") {
								window.open(href);
							} else {
								document.location = href;
							}
						}
					}
				});
			}

		});

		return this;
	};

	$.fn.resizeEmbed = function(options) {
		var defaults = {
		};
		var options = $.extend(defaults, options);
		var obj = $(this);

		obj.each(function() {
			var newWidth = $(this).parent().width();
			$(this)
				// jQuery .data does not work on object/embed elements
				.attr('data-aspectRatio', this.height / this.width)
				.removeAttr('height')
				.removeAttr('width')
				.width(newWidth)
				.height(newWidth * $(this).attr('data-aspectRatio'));
		});

		$(window).on("resize",function() {
			obj.each(function() {
				var newWidth = $(this).parent().width();
				$(this)
					.width(newWidth)
					.height(newWidth * $(this).attr('data-aspectRatio'));
			});
		});

		return this;
	}
})(jQuery);


//RWD checking Fn
function checkMq() {
	// RWD 767 breakpoint checking
	if (Modernizr.mq('all and (max-width: 767px)')) {
		//Adding class for non desktop RWD
		$('html').removeClass("rwd-desktop").addClass("rwd-mobile").trigger("classChange");
		//$('html').css("border-top","solid 10px red");
		//

		//RWD << 767px : match height OFF
		$('.auto-height').matchHeight({ remove: true });
		// console.log("match height OFF");

	//
	}
	else {
		//Adding class for desktop RWD
		$('html').removeClass("rwd-mobile").addClass("rwd-desktop").trigger("classChange");
		//$('html').css("border-top","solid 10px lime");
		//

		//RWD > 767px : : match height ON
		$('.auto-height').matchHeight({});
		// console.log("match height ON");


	//
	}
}

// Jobs offers
//
// RWD 992 breakpoint checking
var fn_job_offer = function() {
	if (Modernizr.mq('all and (min-width: 992px)')) {

		// Initial state : 1st element of each panel is active
		$('.m-offer-list-item').removeClass('active');
		$('.m-offer-list-item').eq(0).addClass("active");
		$(".o-offer-list-display .m-offer-detail").eq(0).show();

		$(".m-offer-list-item-summary").off();
        $(".m-offer-list-item-summary").on("click", function() {
			// we get the rank of the parent to match both divs
			var rank = $(this).parent(".m-offer-list-item").index();

			if ( !$(this).parent(".m-offer-list-item").hasClass("active") ) {
				$(".m-offer-list-item.active").removeClass('active');
				$(this).parent(".m-offer-list-item").addClass("active");

				$(".o-offer-list-display .m-offer-detail").hide();
				$(".o-offer-list-display .m-offer-detail").eq(rank).show();
			}
		})

	}

	if (Modernizr.mq('all and (max-width: 991px)')) {

		// (reinitialize in case of resizing from small devices)
		$('.m-offer-list-item').removeClass('active');
		$('.m-offer-list-item .m-offer-detail').hide();

		$(".m-offer-list-item-summary").off();
        $(".m-offer-list-item-summary").on("click", function() {
			if ( $(this).parent(".m-offer-list-item").hasClass("active") ) {
				$(this).parent(".m-offer-list-item").removeClass("active");
				$(this).siblings(".m-offer-detail").hide();
			} else {
				$(this).parent(".m-offer-list-item").addClass("active");
				$(this).siblings(".m-offer-detail").show();
			}
		})
	}
}

// move all div "details" from the left bar to the right bar, and vice versa
var fn_move_infos = function() {
	if (Modernizr.mq('all and (min-width: 992px)')) {
		$(".o-offer-list-content .m-offer-list-item").each(function() {
			$(".o-offer-list-display").append($(this).find(".m-offer-detail"));
		})
	}

	else if (Modernizr.mq('all and (max-width: 991px)')) {
		$($(".o-offer-list-display .m-offer-detail").get().reverse()).each(function() {
			var rank = $(this).index();
			$(".o-offer-list-content .m-offer-list-item").eq(rank).append($(this));
		})
	}
}

fn_move_infos();

//Sticky NAV
// > Fix affix flickering
function affixFix() {

    var affixElt = $(".header-wrapper");
    var navHeight = $(".header-wrapper").outerHeight();

    // RWD 992 breakpoint checking
    if (Modernizr.mq('all and (min-width: 992px)')) {

        //init affix
        affixElt.affix({
            offset: {
                top: function () {
                    return (this.top = $('.header-wrapper').eq(0).outerHeight(true)); //header + nav height
                }
            }
        });

        const body = document.body;
        const scrollUp = "scroll-up";
        const scrollDown = "scroll-down";
        let lastScroll = 0;

        window.addEventListener("scroll", () => {
            const currentScroll = window.pageYOffset;

            if (currentScroll <= 0) {
                body.classList.remove(scrollUp);
                return;
            }

            if (currentScroll > lastScroll && !body.classList.contains(scrollDown)) {
                // down
                body.classList.remove(scrollUp);
                body.classList.add(scrollDown);
            } else if (
                currentScroll < lastScroll &&
                body.classList.contains(scrollDown)
            ) {
                // up
                body.classList.remove(scrollDown);
                body.classList.add(scrollUp);
            }
            lastScroll = currentScroll;
        });

        //fix affix flickering
        $(".header-wrapper").on('affix.bs.affix', function () {

            $("body").css("margin-top", navHeight);

        }).on('affix-top.bs.affix', function () {

            $("body").css("margin-top", 0);

        });

    } else {

        $("body").css("margin-top", 0);

        //destroy affix
        $(window).off('.affix');
        affixElt.removeClass('affix affix-top affix-bottom').removeData();

    }
}

//isElementOutViewport
function isElementOutViewport(el) {
    var rect = el.getBoundingClientRect();

    return (
        rect.bottom < 0 ||
        rect.right < 0 ||
        rect.left > window.innerWidth ||
        rect.top > window.innerHeight
    );
}